(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsPropertiesHistoryController', TabObjectsPropertiesHistoryController);

    TabObjectsPropertiesHistoryController.$inject = ['ParseLinks', '$stateParams', 'entity', 'property', 'paginationConstants', 'TabOverrideProperties', 'AlertService'];

    function TabObjectsPropertiesHistoryController(ParseLinks, $stateParams, entity, property, paginationConstants, TabOverrideProperties, AlertService) {
        var vm = this;
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.updates = [];
        vm.loadAll = loadAll;

        entity.$promise.then(function () {
            vm.tabObject = entity;
            property.$promise.then(function () {
                vm.property = property;
                loadAll();
            });
        });

        function loadAll() {
            TabOverrideProperties.query({
                propertyId: property.id,
                objectUniqueCode: entity.objectUniqueCode,
                page: vm.page,
                sort: "createdDate,desc",
                size: 20
            }, onSuccess, onError);

            function onSuccess(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.updates = result;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();
